import { TopsportschoolLocatie } from "./TopsportschoolLocatie";
import './PopupTopsportScholen.scss';

export const PopupTopsportScholen = (props) => {
    return <div className="c-detail-fiche__body">
        <div className="practical">
            <div className="left">
                <div className="inner">
                    <PopupTopsportScholenSideBar dictionary={props.dictionary} data={props.data}
                    />
                </div>
            </div>
            <div className="right">
                <PopupTopsportScholenBody dictionary={props.dictionary} data={props.data} />
            </div>
        </div>
    </div>;
}

const PopupTopsportScholenSideBar = (props) => {
    return <div className="bottom">
        <div className='info'>
            <p className="title">
                {props.dictionary.offer}
            </p>
            <div dangerouslySetInnerHTML={{ __html: props.data.detailSideBar.offer }}></div>
        </div>
        <div className="info">
            <p className="title">
                {props.dictionary.topSportsSchoolCoordinator}
            </p>
            <p>
                <i className={props.data.detailSideBar.contactName.icon}></i> {props.data.detailSideBar.contactName.text}
            </p>
            <p>
                <a href={`mailto:${props.data.detailSideBar.contactMail.text}`}>
                <i className={props.data.detailSideBar.contactMail.icon}></i> {props.data.detailSideBar.contactMail.text}</a>
            </p>
        </div>
    </div>;
}

const PopupTopsportScholenBody = (props) => {
    const CreateLocationBlocks = (data) => {
        const blocks = [];
        data.forEach(location => {
            blocks.push(
                <TopsportschoolLocatie data={location} />
            );
        });
        return blocks;
    }
    return <div className="inner">
        {CreateLocationBlocks(props.data.detailBody.locations)}
    </div>;

}
